import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { websiteAPIService } from '~/api/microsites/website';
import WorldIcon from '~/assets/icons/svgs/world.svg?react';
import UrlTextField from '~/components/atoms/UrlTextField';
import { qrCodeKeys } from '~/constants/queryKeys';

type AnonymousWebsiteQRProps = {
  qrCodeId?: number;
  websiteQrId?: number;
};
export default function AnonymousWebsiteQR({ qrCodeId, websiteQrId }: AnonymousWebsiteQRProps) {
  const queryClient = useQueryClient();

  const [urlValue, setUrlValue] = useState('https://example.com');

  const { mutate: updateWebsiteQR } = useMutation({
    mutationFn: websiteAPIService.updateWebsiteSite,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: qrCodeKeys.websiteQrData });
    },
  });

  const handleBlur = ({ isValid }) => {
    if (isValid) {
      updateWebsiteQR({
        id: websiteQrId,
        body: {
          url: urlValue,
          qr_code_id: qrCodeId,
        },
      });
    }
  };

  return (
    <UrlTextField
      requireProtocol={false}
      validateImmediately={false}
      urlValue={urlValue}
      onChange={(e) => setUrlValue(e.target.value)}
      icon={<WorldIcon width={18} height={18} />}
      required={false}
      onBlur={handleBlur}
    />
  );
}
